import { useQuery } from '@apollo/client';

import { EShellMode } from 'types';

import { IHostsResponse, IReturnValue } from './interfaces';
import { HOSTS } from './schema';

export function useHostStatuses(): IReturnValue {
  const { data, error, loading } = useQuery<IHostsResponse>(HOSTS, {
    fetchPolicy: 'no-cache',
    pollInterval: 25000,
    onError: console.error,
  });

  const { hostsOverview } = data ?? { hostsOverview: [] };

  if (loading) {
    return {
      busy: null,
      inService: null,
      on: null,
      shell_high: null,
      shell_off: null,
      hosts: null,
      isWorker: null,
      loading: loading,
    };
  }
  if (error || hostsOverview.length === 0) {
    return {
      busy: null,
      inService: null,
      on: null,
      shell_high: null,
      shell_off: null,
      hosts: null,
      isWorker: null,
    };
  }

  const hostsWithSession = hostsOverview.filter(
    (host) => host.client_sessions.length >= 1
  );

  const hostsShellHigh = hostsOverview.filter(
    (host) => host.shell_mode === EShellMode.HIGH_ACCESS
  );
  const hostsShellOff = hostsOverview.filter(
    (host) => host.shell_mode === EShellMode.DISABLED
  );

  const workerOnHost = hostsOverview.filter(
    (host) => host.user && host.user.roles.length > 0
  );

  const hosts = hostsOverview.length;
  const busy = hostsWithSession.length;
  const inService = hostsOverview.filter((host) => host.in_service).length;
  const on = hostsOverview.filter((host) => host.online).length;
  const shell_high = hostsShellHigh.length;
  const shell_off = hostsShellOff.length;
  const isWorker = workerOnHost.length;

  return {
    hosts,
    busy,
    inService,
    on,
    shell_high,
    shell_off,
    isWorker,
    loading,
  };
}
